module.exports = __webpack_public_path__ + "img/blogging.d2b7a1ba.png";